import { useAtom } from "jotai";
import { isMinimizedAtom } from "../../jotai-store/isMapShow";


const NotATruckModal = ({ onClose, isNotATruckModalOpen , tripStatus }) => {
    const [isMinimized, setIsMinimized] = useAtom(isMinimizedAtom); 
  if (!isNotATruckModalOpen) return null;

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-[#7876A1]/50 px-[24px] py-[18px] font-instrument">
      <div className="relative max-w-[328px] w-full bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Close button top-left */}
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute left-4 top-4 w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600"
        >
          <img
            src="/Vision Agent Icons/X Icon/XLightpurple.svg"
            alt="Close Icon"
          />
        </button>

        <div className="px-6 pt-8 pb-6 text-center">
          {/* Circular man icon with info badge */}
          <div className="relative flex items-center justify-center">
            <div className="rounded-full bg-[#E3E3FF] w-[103px] h-[103px] flex items-center justify-center">
              <img
                src="/images/NewUiIcons/ItemManIcons.png"
                alt="man icon"
                // className="w-[103px] h-[103px] object-contain"
              />
            </div>

            <div className="absolute top-1 z-[1000] left-40 translate-x-3 bg-[#34318C] h-[31px] w-[31px] rounded-full flex items-center justify-center">
              <img
                src="/images/NewUiIcons/InfoIcon.svg"
                alt="info"
                className="w-[17px] h-[17px] object-contain filter invert brightness-0"
              />
            </div>
          </div>

          <p className="mt-6 text-[14px] text-[#34318C] font-normal leading-5">
            For jobs where you just need movers, <br />
            <span className="font-extrabold">NOT a truck</span>, like moving
            furniture within your home or loading/unloading a truck or storage
            pod.
          </p>

          <button
            onClick={onClose}
            className="mt-[16px] w-full bg-[#34318C] text-white flex justify-center items-center py-3 h-[44px] rounded-[15px] font-semibold text-[16px] shadow-sm hover:bg-[#2d2a6b]"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotATruckModal;
